import { Mappable, Mapped } from '../../rest/decorators/mapped'
import { StreamCommissionImage } from './stream-commission-image'

@Mapped(
  {
    images: { format: StreamCommissionImage.create },
    sim_card_number: { property: 'simCardNumber' },
    is_sim_card_still_present: { property: 'simCardStillPresent' },
    serial_number: { property: 'serialNumber' },
    firmware_version: { property: 'firmwareVersion' },
    completed_at: { property: 'completed', type: 'date' },
  },
  ['numericID', 'timestamps']
)
export class StreamCommission extends Mappable {
  id!: string | number
  numericID!: number
  ulid!: string
  images?: StreamCommissionImage[]
  registration!: string | null
  simCardNumber!: string | null
  simCardStillPresent!: boolean | null
  serialNumber!: string | null
  firmwareVersion!: string | null
  completed!: Date | null
  created!: Date
  updated!: Date
  deleted!: boolean

  static create<Data>(attrs: Data) {
    return new StreamCommission().map(attrs)
  }

  imageForResult(result: string) {
    return this.images?.find(
      (image) => image.results.findIndex(({ id }) => id === result) >= 0
    )
  }
}
